import React, { ChangeEvent, useState } from 'react'
import {
  CButton,
  CCard,
  CCardBody,
  CCardHeader,
  CCol,
  CForm,
  CFormInput,
  CFormSelect,
  CRow,
  CSpinner,
  CTabContent,
} from '@coreui/react-pro'
import { useEditBudgetItem } from './hooks'
import { setBudgetItem, submitEditBudgetItem } from './model'

export const EditBudgetItem = () => {
  const [validated, setValidated] = useState(false)

  const { budgetItem, section, loadingBudgetItem } = useEditBudgetItem()

  const handleChange = (
    event: ChangeEvent<
      HTMLInputElement | HTMLSelectElement | HTMLTextAreaElement
    >,
  ) => {
    let value = event.currentTarget.value

    setBudgetItem({
      ...budgetItem,
      [event.currentTarget.name]: value,
    })
  }

  const handleSubmit = (event: React.FormEvent<HTMLFormElement>) => {
    const form = event.currentTarget

    if (!form.checkValidity()) {
      event.preventDefault()
      event.stopPropagation()
    } else {
      submitEditBudgetItem({
        ...budgetItem,
        section: budgetItem.sectionId,
      })
      event.preventDefault()
      event.stopPropagation()
    }
    setValidated(true)
  }

  if (loadingBudgetItem) {
    return (
      <div className="d-flex justify-content-center align-items-center">
        <CSpinner />
      </div>
    )
  }

  return (
    <CCard className="mb-4">
      <CCardHeader className="d-sm-flex justify-content-between align-items-center">
        <strong>Edit budget item</strong>
      </CCardHeader>
      <CCardBody>
        <CTabContent className="pt-3">
          <CForm noValidate validated={validated} onSubmit={handleSubmit}>
            <CRow className="mb-3">
              <CCol sm={4}>
                <CFormInput
                  type="text"
                  id="name"
                  name="name"
                  value={budgetItem.name}
                  onChange={handleChange}
                  label="Name"
                  required
                />
              </CCol>
              <CCol sm={4}>
                <CFormSelect
                  id="sectionId"
                  name="sectionId"
                  value={budgetItem.sectionId}
                  onChange={handleChange}
                  label="Section"
                  required
                >
                  <option value="">Choose section</option>
                  {section.map((item) => (
                    <option value={item.id} key={item.id}>
                      {item.name}
                    </option>
                  ))}
                </CFormSelect>
              </CCol>
            </CRow>
            <CButton className="mb-3" type="submit">
              Edit
            </CButton>
          </CForm>
        </CTabContent>
      </CCardBody>
    </CCard>
  )
}
